// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__1tn4K","skillsContainer":"Skills_skillsContainer__0qsit","skills":"Skills_skills__JGGR9"};